import {
    ATTENDANCE_TRANSCRIPTION_SETTING,
    TRANSCRIPTION_FEATURE,
    TRANSCRIPTION_MONTHLY_LIMIT_FEATURE,
    TRANSCRIPTION_SETTINGS_PAGE_SETTING,
} from "@vhealth/transcription/model";
import { SNCR_INTEGRATION_SETTING } from "@app/wapps/system/integration/sncr/sncr.model";

export class HealthFeatures {
    static MedicalRecord = "Health.Features.MedicalRecord";
    static PregnancyCard = "Health.Features.PregnancyCard";
    static Prescription = "Health.Features.Prescription";
    static SmartPrescription = "Health.Features.SmartPrescription";
    static SmartPrescriptionV1 = "Health.Features.Prescription.Smart";
    static Exam = "Health.Features.Exam";
    static Files = "Health.Features.Files";
    static Schedule = "Health.Features.Schedule";
    static ReportAttendance = "Health.Features.Report.Attendance";
    static ReportSchedules = "Health.Features.Report.Schedules";
    static Dashboard = "HealthFeatures.FeatureDashboard";
    static Engage = "Health.Features.Engage";
    static PrescriptionDraft = "Health.Prescription.DraftEnabled";
    static TemplatePartials = "Health.Document.TemplatePartials.Enabled";
    static OnlineMedicalCare = "Health.Features.OnlineMedicalCare";
    static OnlineMedicalCareLimit = "Health.Features.OnlineMedicalCare.MonthlyLimit";
    static ProfessionalsLimit = "Health.Features.Professionals.Limit";
    static MeetDomain = "Features.Meet.Domain";
    static FeatureFiles = "HealthFeatures.FeatureFiles";
    static Transcriptions = TRANSCRIPTION_FEATURE;
    static TranscriptionsMonthlyLimit = TRANSCRIPTION_MONTHLY_LIMIT_FEATURE;
    static AttendanceTranscription = ATTENDANCE_TRANSCRIPTION_SETTING;
    static TranscriptionSettingsPage = TRANSCRIPTION_SETTINGS_PAGE_SETTING;
    static SncrIntegration = SNCR_INTEGRATION_SETTING;

    public static isSmartPrescriptionEnabled() {
        return (
            abp.features.isEnabled(HealthFeatures.SmartPrescription) ||
            abp.features.isEnabled(HealthFeatures.SmartPrescriptionV1)
        );
    }
}
